import { render, staticRenderFns } from "./UiSelectAction.vue?vue&type=template&id=094497fa"
import script from "./UiSelectAction.vue?vue&type=script&lang=js"
export * from "./UiSelectAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports